import { useEffect, useState } from 'react';

export const useWindowSize = (size: number = 1440) => {
  const [status, setStatus] = useState(false)

  useEffect(() => {
    setStatus(window.innerWidth <= size);

    const handleResize = () => {
      setStatus(window.innerWidth <= size);
    };

    window.addEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setStatus(window.innerWidth <= size);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return status;
};